import React, {  useState } from "react";
import TogglerBody from "../../TogglerBody";
import CustomSliderRange from "../../sliders/CustomSliderRange";
import ChooseActionTamplate from "../../actionTamplate/ChooseActionTamplate";
import TipsTamplate from "../../TipsTamplate";
import {statusActions} from '../../../../constants/common'


const StatustamplateFaceDetection = ({data}) => {
  const [isOnMonitor, setIsOnMonitor] = useState(data?.data?.enabled);
  const [isOnPunish, setIsOnPunish] = useState(data?.data?.applyPunishment);
  const [currentAction, setCurrentAction] = useState(data?.data?.punishment || "Kick");


  return (
    <div style={{ maxHeight: "430px" }} className="status_block_wrap">
      <div className="status_block_wrap_bg"></div>
      <img
        className="status_block_wrap_img"
        src="/img/StatusBlock.svg"
        alt=""
      />
      <h3>Status</h3>
      <div
        className="status_block_item"
        style={{ borderBottom: "1px solid #8D99A3" }}
      >
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isOnMonitor} setIsOn={setIsOnMonitor} keyName={"enabled"} />
          <p>Use Fake Detection feature</p>
        </div>
      </div>
      <div className="status_block_item">
        <div className="status_block_item_toggler">
          <TogglerBody isOn={isOnPunish} setIsOn={setIsOnPunish} keyName={"applyPunishment"} />

          <div className="white_list_block_item_title_block flag_customisation_item_wrap_title">
            <p>Apply Global Punishment</p>
            <TipsTamplate
              title={"Global Punishment"}
              label={"Safe"}
              text={
                "<p>Punishment represents what Themis does once this flag is triggered and the total amount of flags accumulated by the member surpasses the limit.</p>"
              }
              textSecond={
                "<p>Punishment type and sensitivity can be override using Advanced Settings</p>"
              }
            />
          </div>
        </div>
        <ChooseActionTamplate
          keyName={"punishment"}
          currentAction={currentAction}
          setCurrentAction={setCurrentAction}
          actionArr={statusActions}
        />
      </div>
      <div style={{ marginTop: "40px" }} className="status_block_item">
        <div className="white_list_block_item_title_block flag_customisation_item_wrap_title">
          <p className="white_list_block_item_title pro_title">
            Scan Wave Frequency{" "}
            <label className="fake-status-pro" htmlFor="">
              PRO
            </label>
          </p>
          <TipsTamplate
            title={"Scan Wave Frequency"}
            label={"Safe"}
            text={
              "<p>Scan Wave Frequency setting lets you enter a time interval, specified in minutes, after which the scan wave will occur.</p>"
            }
            textSecond={
              "<p>Scan Wave is when Themis checks the user name of all users for a local dictionary match.</p>"
            }
          />
        </div>

        <CustomSliderRange
          data={data}
          keyName={"waveFrequency"}
          currentAction={currentAction}
          setCurrentAction={setCurrentAction}
          item={statusActions}
          color={"yellow"}
        />
      </div>
      {/* <div className='status_block_item'>
                <div className='status_block_item_toggler'>
                    <TogglerBody
                    isOn={isOnPunish}
                    setIsOn={setIsOnPunish}
                    />
                    <p>Use Rulesets</p>
                </div>
                    <div className='input_checkbox_user_wrap'>
                        {userList.map((item, id) => (
                            
                            <InputCheckBoxUser
                            key={id}
                            item={item}
                            // setCheckBox={setCheckBox}
                            // checkBox={checkBox}
                            />
                        ))
                        }
                    </div>

            </div> */}
    </div>
  );
};

export default StatustamplateFaceDetection;
